module.exports = __webpack_public_path__ + "assets/img/kroscina-wielka.6d427835.jpg";